const NAME_PREFIX = "HBB:$"
export const HBB_STORE_NAME = NAME_PREFIX + "hbbCRMState"

export const EMPLOYEE_PROFILE = "EMPLOYEE"
export const SELLER_PROFILE = "SELLER"
export const CUSTOMER = "CUSTOMER"
export const SELLER_CATEGORY = "SELLER"

export const RESET_PASSWORD="Reset Password"

//brands
export const BRANDS_TABLE = "Brands List"
export const ADD_BRAND = "Brands List - Add Brand"
export const EDIT_BRAND = "Brands List - Edit Brand"
export const BRANDS_DETAILS = "Brand View"


//attendane
export const ATTENDANCE_TABLE = "Attendance List"
export const ADD_ATTENDANCE = "Attendance List - Mark Attendance"
export const EDIT_ATTENDANCE = "Attendance List - Update Attendance"


//attendane
export const ORDER_VERIFICATION_TABLE = "Order Verification List"



//privileges
export const PRIVILEGES_TABLE = "Privileges List"
export const ADD_PRIVILEGES = "Privileges List - Add Privilges"
export const EDIT_PRIVILEGES = "Privileges List - Edit Privilges"

//employess
export const EMPLOYEES_TABLE = "Employees List"
export const ADD_EMPLOYEE = "Employees List - Add Employee"
export const EDIT_EMPLOYEE = "Employees List - Edit Employee"
export const VIEW_EMPLOYEE = "Employees List - View Employee"
export const EMPLOYEE_RESOURCES_TABLE = "Employees List - Employee Resources"


//employess
export const CATEGORIES_TABLE = "Menu Categories List"
export const ADD_CATEGORY= "Menu Categories List - Add Category"
export const EDIT_CATEGORY = "Menu Categories List - Edit Category"

//menus
export const MENUS_TABLE = "Menus List"
export const ADD_MENU= "Menus List - Add Menu"
export const EDIT_MENU = "Menus List - Edit Menu"

//Assets
export const ASSETS_TABLE = "Assets"
export const ADD_ASSET= "Assets - Add Asset"
export const EDIT_ASSET = "Assets - Edit Asset"

//Equipments
export const EQUIPMENTS_TABLE = "Equipments"
export const ADD_EQUIPMENT= "Equipments - Add Equipment"
export const EDIT_EQUIPMENT = "Equipments - Edit Equipment"

//Assets Types
export const ASSET_TYPES_TABLE = "Equipment Categories"
export const ADD_ASSET_TYPE= "Equipment Categories - Add Equipment Category"
export const EDIT_ASSET_TYPE = "Equipment Categories - Edit Equipment Category"

//Assets Vendors
export const ASSET_VENDORS_TABLE = "Asset Vendors"
export const ADD_ASSET_VENDOR= "Asset Vendors - Add Asset Vendor"
export const EDIT_ASSET_VENDOR = "Asset Vendors - Edit Asset Vendor"

//Assets Locations
export const ASSET_LOCATIONS_TABLE = "Asset Locations"
export const ADD_ASSET_LOCATION= "Asset Locations - Add Asset Location"
export const EDIT_ASSET_LOCATION = "Asset Locations - Edit Asset Location"

//menus
export const MENU_DISABLED_TICKETS_TABLE = "Menu Disabled Tickets"
export const EDIT_MENU_DISABLED_TICKET = "Menu Disabled Tickets - Edit Ticket"





//kitchen staff table
export const KITCHEN_STAFFS_TABLE = "Kitchen Staffs List"
export const ADD_KITCHEN_STAFF= "Kitchen Staffs List - Add Kitchen Staff"
export const EDIT_KITCHEN_STAFF = "Kitchen Staffs List - Edit Kitchen Staff"

//employee depute table
export const EMPLOYEE_DEPUTE_TABLE = "Employees Deputy List"
export const ADD_EMPLOYEE_DEPUTE= "Employees Deputy List - Create Depute"

//employee rehire table
export const EMPLOYEE_REHIRE_TABLE = "Employees Rehire List"
export const ADD_EMPLOYEE_REHIRE= "Employees Rehire List - Rehire Employee"

//employee promotion table
export const EMPLOYEE_PROMOTION_TABLE = "Employees Promotion List"
export const ADD_EMPLOYEE_PROMOTION= "Employees Promotion List - Promote Employee"




//users table
export const USERS_TABLE = "Users List"


//employess attrition
export const EMPLOYEES_ATTRITION_TABLE = "Employee Attritions List"
export const EDIT_EMPLOYEE_ATTRITION = "Employee Attritions List - Edit"


//teams
export const TEAMS_TABLE = "My Team"
export const ADD_EMPLOYEE_ATTRITION = "My Team - Add Attrition"
export const ADD_ATTENDANCE_TABLE = "My Team - Add Attendance"


//roles
export const ROLES_TABLE = "Roles List"
export const ADD_ROLE = "Roles List - Add Role"
export const EDIT_ROLE = "Roles List - Edit Role"

//designation
export const DESIGNATIONS_TABLE = "Designations List"
export const ADD_DESIGNATION = "Designations List - Add Designation"
export const EDIT_DESIGNATION = "Designations List - Edit Designation"



//departments
export const DEPARTMENTS_TABLE = "Departments List"
export const ADD_DEPARTMENT = "Departments List - Add Department"
export const EDIT_DEPARTMENT = "Departments List - Edit Department"

//departments teams
export const DEPARTMENT_TEAMS_TABLE = "Department Team List"
export const ADD_DEPARTMENT_TEAM = "Department Team List - Add Team"
export const EDIT_DEPARTMENT_TEAM = "Department Team List - Edit Team"




//departments
export const WORKLOCATIONS_TABLE = "Work Locations List"
export const ADD_WORKLOCATION = "Work Locations List - Add Work Location"
export const EDIT_WORKLOCATION = "Work Locations List - Edit Work Location"


//cost centers
export const COSTCENTERS_TABLE = "Cost Centers List"
export const ADD_COSTCENTER = "Cost Centers List - Add Cost Center"
export const EDIT_COSTCENTER = "Cost Centers List - Edit Cost Center"


//Reasons
export const REASONS_TABLE = "Reasons List"
export const ADD_REASON = "Reasons List - Add Reason"
export const EDIT_REASON = "Reasons List - Edit Reason"



//stocks
export const PRODUCTS_STOCKS_TABLE = "Product Stocks List"
export const PRODUCTS_STOCKS_LIST = "Product Stocks List"
export const PRODUCTS_UPDATE_STOCKS_TABLE ="Product Stocks List - Update Stocks"


//Kits
export const KITS_TABLE = "Kits"
export const KITS_PRODUCTS_TABLE = "Kits - Products List"
export const KITS_PRODUCTS_UPDATE_TABLE = "Kits - Products List - Update"
export const KITS_STORES = "Kits - Stores List"
export const KITS_STORES_UPDATE_LOCATION = "Kits - Stores List - Update Location"
//export const KITS_UPDATE_LOCATION = "Kits Update Location"


//Stores
export const STORES_TABLE = "Stores List"
export const ADD_STORE = "Stores List - Add Store"
export const EDIT_STORE = "Stores List - Edit Store"
export const ADD_EDIT_STORE_TIMING = "Stores List - Add/Edit Store Timing"
export const STORES_TICKETS_TABLE = "Store Tickets"
export const EDIT_STORE_TICKET = "Store Tickets - Update Ticket"
export const ASSIGN_AGENT_STORE_TICKET = "Store Tickets - Assign Agent"
export const STORES_TICKETS_LIVE_TABLE = "Store Tickets - Live Tickets"

export const ST_AGENTS_TABLE = "Store Tickets Agents List"
export const ADD_ST_AGENT_KITCHENS = "Store Tickets Agents List - Add Kitchens"


export const ST_REPORTS_TABLE = "Store Tickets Summary"



//HR
export const HR_TICKETS_TABLE = "HR Tickets List"
export const ADD_HR_TICKET = "HR Tickets List - Create Ticket"
export const EDIT_HR_TICKET = "HR Tickets List - Edit Ticket"


//cities
export const CITIES_TABLE = "Cities List"
export const ADD_CITIES = "Add City"
export const EDIT_CITIES = "Edit City"

//clusters
export const CLUSTERS_TABLE = "Clusters List"
export const ADD_CLUSTER = "Add Cluster"
export const EDIT_CLUSTER = "Edit Cluster"

//employees Movement
export const EMPLOYEES_MOVEMENT_TABLE = "Employee Movements List"
export const ADD_EMPLOYEE_MOVEMENT = "Create Employee Movement"


//kitchen
export const KITCHENS_TABLE = "Kitchens List"
export const ADD_KITCHEN = "Kitchens List - Add Kitchen"
export const EDIT_KITCHEN = "Kitchens List - Edit Kitchen"
export const VIEW_KITCHEN_TEAM = "Kitchens List - View Team"


//kitchen
export const EMPLOYEE_PAY_SCALES_TABLE = "Employee Pay Scales List"
export const ADD_EMPLOYEE_PAY_SCALE = "Employee Pay Scales List - Add Pay Scale"
export const EDIT_EMPLOYEE_PAY_SCALE = "Employee Pay Scales List - Edit Pay Scale"




//Entity Types
export const ENTITY_TYPES_TABLE = "Entity Types List"
export const ADD_ENTITY_TYPE = "Entity Types List - Add Entity Type"
export const EDIT_ENTITY_TYPE = "Entity Types List - Edit Entity Type"

//Entity Status
export const ENTITY_STATUS_TABLE = "Entity Status List"
export const ADD_ENTITY_STATUS = "Entity Status List - Add Entity Status"
export const EDIT_ENTITY_STATUS = "Entity Status List - Edit Entity Status"


//Attendance Sumarry
export const ATTENDANCE_SUMMARY_TABLE = "Kitchen Headcount Summary"


//New Joinee
export const NEW_JOINEE_TABLE = "New Joinees List"





//Platforms
export const PLATFORMS_TABLE = "Platforms List"
export const ADD_PLATFORM = "Platforms List - Add Platform"
export const EDIT_PLATFORM  = "Platforms List - Edit Platform"


//Sellers
export const SELLERS_TABLE = "Sellers List"
export const ADD_SELLER = "Add Seller"
export const EDIT_SELLER = "Edit Seller"
export const SELLER_DETAILS = "Seller View"
export const SELLER_PROFILE_LABEL = "Seller Profile" 
export const CATEGORY_TYPE_TEST ="TEST"


//Orders
export const ORDER_GROUPS_TABLE = "Order Groups List"
export const ORDERS_STATISTICS_TABLE = "Order Statistics List"
export const ORDERS_TABLE = "Orders List"
export const ORDER_ADD ="Order Add"
export const LINE_ITEM_DETAILS = "Line Item Details"

//products
export const PRODUCT_LIST_TABLE = "Products List"


//Daily Menu
export const DAILY_MENU_TABLE = "Daily Menu List"
export const DAILY_MENU_BULK_UPLOAD = "Daily Menu Bulk Upload"
export const DAILY_MENU_ADD = "Daily Menu Add"

//prducts
export const PRODUCT_LIST = "Products List"









//others
export const ADD_RECIPE = "Add Recipe"

export const ADD_PRODUCT = "Add Product"


export const EDIT_PRODUCT = "Edit Product"

export const TYPE_VEG = "Veg"
export const TYPE_NON_VEG = "Non Veg"


export const CUSTOMER_LIST = "Customer List"

export const ADD_CUSTOMER = "Add Customer"
export const EDIT_CUSTOMER = "Edit Customer"

export const COMPANY_LIST = "Company List"

export const ADD_COMPANY = "Add Company"
export const EDIT_COMPANY = "Edit Company"

export const MESSAGES_LIST = "Message List"


export const RECIPE_LIST = "Recipe List"

export const ATTENDANCE_CYCLES_TABLE = "Attendance Cycles List"



export const NON_VALID_MSG_INPUT ="Please Fill"
export const NON_VALID_MSG_SELECT ="Please Select"
export const NON_VALID_MSG_CHOOSE ="Please Choose"
export const NON_VALID_MSG_INPUT_NUMBER ="Please enter valid number"
export const NON_VALID_EMAIL ="Please enter valid email"
export const NON_VALID_PHONE ="Please enter valid phone number"

export const NON_VALID_LATITUDE ="Please enter valid latitude"
export const NON_VALID_LONGITUDE ="Please enter valid longitude"


export const FORM_INPUT ="input"
export const FORM_SELECT ="select"
export const FORM_CHOOSE ="choose"


export const TECH_SETTINGS="Tech Settings"
export const EDIT_SELLER_PROFILE="Edit Seller Profile"


export const INPROGRESS_REQUEST = "INPROGRESS"
export const COMPLETED_REQUEST = "COMPLETED"
export const NEW_REQUEST = "NEW"
export const PUBLISH_REQUEST = "PUBLISHED"
export const CANCEL_REQUEST = "CANCELLED"
export const CANCEL_FREE_REQUEST = "FREE CANCEL"
export const CANCEL_PAID_REQUEST = "PAID CANCEL"
export const CONFIRM_REQUEST = "CONFIRMED"
export const READY_REQUEST = "READY TO PICKUP"
export const REQUESTED_TO_CANCEL_REQUEST = "REQUESTED TO CANCEL"
export const RETURN_REQUEST = "RETURNED"
export const REPLACEMENT_REQUEST = "REPLACED"
export const EXCHANGE_REQUEST = "EXCHANGED"
export const OPEN_REQUEST = "OPEN"
export const CLOSED_REQUEST = "CLOSED"
export const PUSHED_TO_LOGISTICS_REQUEST = "PUSHED TO LOGISTICS"
export const DELIVERED_REQUEST = "DELIVERED"
export const PICKED_REQUEST = "PICKED"
export const VERIFIED_REQUEST = "VERIFIED"
export const REACHED_HUB_REQUEST = "REACHED HUB"

export const FIRST_LEG_TYPE ="FIRST"
export const SECOND_LEG_TYPE ="SECOND"
export const STRAIGHT_LEG_TYPE ="STRAIGHT"

export const SLOT_ONE = "Slot 1"
export const SLOT_TWO = "Slot 2"

export const PRODUCT_TYPES_LIST = "product_types_list" 
export const CUISINE_LIST = "cuisine_list"
export const CATEGORY_LIST = "categoryn_list"

export const CANCEL_REASON ="CANCEL_ORDER"
export const REQUEST_TO_CANCEL_REASON ="REQUEST_CANCEL_ORDER"

export const TOPIC_ORDER_LIST ="orders"
export const TOPIC_ORDER_STATISTIC ="orderstatistics"
export const TOPIC_ORDER_SUMMARY ="ordersummary"
export const TOPIC_DAILY_MENU_LIST ="daily_menus"
export const TOPIC_MESSAGE_LIST ="wabox_messages"
export const TOPIC_GROUP_LIST ="groups"


export const HOLIDAY_ON = "HOLIDAY ON"
export const HOLIDAY_OFF = "HOLIDAY OFF"
export const HOLD = "HOLD"
export const UNHOLD = "UN HOLD"

export const HOLIDAY_MODE = "ON HOLIDAY"
export const HOLD_MODE = "ON HOLD"
export const PRESET_MODE = "PRESENT"


// WEBPACK FOOTER //
// ./src/common/constants.js